export default {
    SELECTED_PERIOD: 'SELECTED_PERIOD',
    PARENTDASH: {
        SELECTED_CHILD: 'parentDash_Child'
    },
    SPA_CONFIG: {
        BASE: 'SPA_CONFIG',
        FILTER_SELECTION: 'FILTER_SELECTION',
        TABLE_SELECTION: 'TABLE_SELECTION'
    },
    USER: {
        TOKEN: 'token'
    }
};